import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { WA_LINK } from "@/components/site/content";

const SLIDES = [
  ["/assets/slide1.webp", "Trusted Online Cricket ID"],
  ["/assets/slide2.png", "Online Cricket ID Bonus Offers"],
];

export const HeroSlider = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);
  const go = (d) => setI((x) => (x + d + SLIDES.length) % SLIDES.length);

  return (
    <section id="home" className="relative overflow-hidden bg-black" data-testid="hero-slider">
      <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${i * 100}%)` }}>
        {SLIDES.map(([src, alt], k) => (
          <a key={src} href={WA_LINK} data-testid={`hero-slide-${k}`} className="w-full shrink-0">
            <img src={src} alt={alt} className="w-full h-auto max-h-[640px] object-cover" />
          </a>
        ))}
      </div>
      {[[-1, ChevronLeft, "left-3", "prev"], [1, ChevronRight, "right-3", "next"]].map(([d, Icon, pos, id]) => (
        <button key={id} onClick={() => go(d)} data-testid={`hero-slide-${id}`} aria-label={id}
          className={`absolute ${pos} top-1/2 -translate-y-1/2 grid place-items-center w-10 h-10 rounded-full bg-black/50 text-white hover:bg-[#ffcc00] hover:text-black transition-colors`}>
          <Icon className="w-5 h-5" />
        </button>
      ))}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {SLIDES.map((s, k) => (
          <button key={s[0]} onClick={() => setI(k)} data-testid={`hero-dot-${k}`} aria-label={`Slide ${k + 1}`}
            className={`h-2 rounded-full transition-[width,background-color] ${i === k ? "w-6 bg-[#ffcc00]" : "w-2 bg-white/60"}`} />
        ))}
      </div>
    </section>
  );
};
